(function() {
  'use strict';

  function PrintLabel($q, Pedido) {

    var PrintLabel = {};

    var deferred;

    function openPdf(pdf) {
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(pdf.response);
      } else {
        var objectUrl = URL.createObjectURL(pdf.response);
        window.open(objectUrl);
      }
      deferred.resolve(true);
    }

    function sendToPrint(labelsCode, unique) {
      Pedido.printLabel(labelsCode)
        .then(function(pdf) {
          var obj = {
            Source: window.location.pathname.indexOf('historico') == -1 ? 'Package list' : 'Order history',
            Button_type: unique ? 'Inline' : 'Batch',
            Labels_selected: labelsCode.length
          };
          openPdf(pdf);
        })
        .catch(function(error) {
          deferred.reject(error);
        });
    }

    PrintLabel.getLabelsToPrint = function(orders) {

      if(_.isNull(orders) || _.isUndefined(orders)) {
        return;
      }

      deferred = $q.defer();

      if (_.isPlainObject(orders)) {
        var codes = [];
        for (var chk in orders.items) {
          if (orders.items[chk]) {
            codes.push(chk);
          }
        }
        sendToPrint(codes, false);
        return deferred.promise;
      } else {
        var ordersList = _.isArray(orders) ? orders : [orders];
        sendToPrint(ordersList, ordersList.length > 1 ?  true : false);
        return deferred.promise;
      }

    };

    return PrintLabel;

  }

  angular
    .module('mandaeApp')
    .factory('PrintLabel', PrintLabel);

}());
